import type { RacquetSportId } from '@court-sync/shared';
import { cn } from '@/lib/utils';
import { getSportIconTileClasses } from '@/lib/sportPresentation';

const SPORT_ICON_BASENAMES: Record<RacquetSportId, string> = {
  tennis: 'tennis',
  pickleball: 'pickleball',
  padel: 'padel',
  badminton: 'badminton',
  squash: 'squash',
  other: 'table-tennis',
};

export type SportIconVariant = 'light' | 'dark';

function getSportIconSrc(sportId: RacquetSportId, variant: SportIconVariant): string {
  const basename = SPORT_ICON_BASENAMES[sportId] ?? SPORT_ICON_BASENAMES.other;
  return `/sports/${basename}-${variant}.svg`;
}

export function SportIcon({
  sportId,
  className,
  variant = 'dark',
}: {
  sportId: RacquetSportId;
  className?: string;
  variant?: SportIconVariant;
}) {
  const src = getSportIconSrc(sportId, variant);

  return (
    <img
      src={src}
      alt=""
      className={cn('object-contain', className)}
      aria-hidden
      draggable={false}
    />
  );
}

export function SportIconTile({
  sportId,
  className,
  iconClassName = 'h-7 w-7',
}: {
  sportId: RacquetSportId;
  className?: string;
  iconClassName?: string;
}) {
  return (
    <span
      className={cn(
        'flex h-10 w-10 shrink-0 items-center justify-center rounded-lg shadow-sm',
        getSportIconTileClasses(sportId),
        className
      )}
      aria-hidden
    >
      <SportIcon sportId={sportId} variant="light" className={iconClassName} />
    </span>
  );
}
